import { render, staticRenderFns } from "./Bus.vue?vue&type=template&id=0094a753&scoped=true"
import script from "./Bus.vue?vue&type=script&lang=js"
export * from "./Bus.vue?vue&type=script&lang=js"
import style0 from "./Bus.vue?vue&type=style&index=0&id=0094a753&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0094a753",
  null
  
)

export default component.exports